import { LEGACY_ORGANIZATION_STATUS_SUSPENDED, OrganizationStatus } from '../enums/OrganizationStatus'

export { OrganizationStatus, LEGACY_ORGANIZATION_STATUS_SUSPENDED }

export type OrganizationStatusValue = OrganizationStatus | typeof LEGACY_ORGANIZATION_STATUS_SUSPENDED

export const DELETABLE_ORGANIZATION_STATUSES: readonly OrganizationStatus[] = [
  OrganizationStatus.PENDING_ONBOARDING,
  OrganizationStatus.DEACTIVATED,
  OrganizationStatus.ARCHIVED
]

const NON_OPERATIONAL_STATUSES = new Set<string>([
  OrganizationStatus.DEACTIVATED,
  OrganizationStatus.ARCHIVED,
  LEGACY_ORGANIZATION_STATUS_SUSPENDED
])

export function isPendingOnboardingStatus(status: OrganizationStatusValue | string | undefined): boolean {
  return status === OrganizationStatus.PENDING_ONBOARDING
}

export function isActiveOrganizationStatus(status: OrganizationStatusValue | string | undefined): boolean {
  return status === OrganizationStatus.ACTIVE
}

export function isDeactivatedOrganizationStatus(status: OrganizationStatusValue | string | undefined): boolean {
  return status === OrganizationStatus.DEACTIVATED || status === LEGACY_ORGANIZATION_STATUS_SUSPENDED
}

export function isArchivedOrganizationStatus(status: OrganizationStatusValue | string | undefined): boolean {
  return status === OrganizationStatus.ARCHIVED
}

export function isNonOperationalOrganizationStatus(status: OrganizationStatusValue | string | undefined): boolean {
  return NON_OPERATIONAL_STATUSES.has(status ?? '')
}

export function isDeletableOrganizationStatus(status: OrganizationStatusValue | string | undefined): boolean {
  return (DELETABLE_ORGANIZATION_STATUSES as readonly string[]).includes(status ?? '')
}

/** Super-admin BO may promote to ACTIVE via activate (pending) or reactivate (deactivated). */
export function canSuperAdminActivateOrganization(status: OrganizationStatusValue | string | undefined): boolean {
  return isPendingOnboardingStatus(status) || isDeactivatedOrganizationStatus(status)
}
